import React, { useState } from 'react';
import styles from './LeagueOverallRanking.module.css';

const LeagueOverallRanking = ({ rankings }) => {
    const [showBreakdown, setShowBreakdown] = useState(false);

    if (!rankings || rankings.length === 0) return null;

    return (
        <div className={styles.container}>
            <div className={styles.headerRow}>
                <h3 className={styles.title}>Ranking Ogólny</h3>
                <label className={styles.breakdownToggle}>
                    <input
                        type="checkbox"
                        checked={showBreakdown}
                        onChange={e => setShowBreakdown(e.target.checked)}
                    />
                    Szczegóły punktacji
                </label>
            </div>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Zawodnik</th>
                        <th>Grupa</th>
                        <th>M</th>
                        <th>W</th>
                        <th>P</th>
                        {showBreakdown && <th title="Punkty za mecze">Mecze</th>}
                        {showBreakdown && <th title="Premia grupowa (pro-ratowana)">Premia</th>}
                        {showBreakdown && <th title="Premia za miejsce w grupie">Miejsce</th>}
                        {showBreakdown && <th title="Kompensacja za zamrożone rundy">Kompensacja</th>}
                        <th>Pkt</th>
                    </tr>
                </thead>
                <tbody>
                    {rankings.map((r) => (
                        <tr key={r.participantId} className={r.frozen ? styles.frozen : ''}>
                            <td>{r.rank}</td>
                            <td>
                                {r.frozen && <span title="Zamrożony">&#10052;&#65039; </span>}
                                {r.playerName}
                            </td>
                            <td>{r.currentGroup || '-'}</td>
                            <td>{r.matchesPlayed}</td>
                            <td>{r.wins}</td>
                            <td>{r.losses}</td>
                            {showBreakdown && <td className={styles.breakdownCell}>{(r.totalMatchPoints ?? 0).toFixed(1)}</td>}
                            {showBreakdown && <td className={styles.breakdownCell}>{(r.totalGroupPremium ?? 0).toFixed(1)}</td>}
                            {showBreakdown && <td className={styles.breakdownCell}>{(r.totalPlaceBonus ?? 0).toFixed(1)}</td>}
                            {showBreakdown && <td className={styles.breakdownCell}>{(r.totalFrozenCompensation ?? 0).toFixed(1)}</td>}
                            <td className={styles.points}>{r.totalWeightedPoints.toFixed(1)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default LeagueOverallRanking;
